import { backendFetch } from './apiUtils';

export const companyLogin = async (formData) => {
  const formattedFormData = new FormData(formData);
  return backendFetch({ url: 'companyLogin', method: 'POST', options: { body: formattedFormData }, authorised: false });
};

export const sendResetPasswordEmail = async (submit) => {
  const formattedFormData = new FormData(submit);
  return backendFetch({
    url: 'forgottenPassword/sendEmail',
    method: 'POST',
    options: { body: formattedFormData },
    authorised: false,
  });
};
